import {register} from '@shopify/theme-sections';

export default register('grid-cta', {
  onLoad() {
    const gridCtaSection = this.container;
    const loadMore = gridCtaSection?.querySelector('button');

    const grid = document.querySelectorAll('.image-grid-section');
    const gridArray = [...grid];

    if (grid.length <= 1) {
      gridCtaSection.classList.add('hidden');
    }

    if (!loadMore) return;

    loadMore.addEventListener('click', () => {
      const hiddenGrid = gridArray.filter((item) => window.getComputedStyle(item).display === 'none');

      if (hiddenGrid.length === 0) return;

      hiddenGrid[0].style.display = 'block';

      if (hiddenGrid.length <= 1) {
        gridCtaSection.parentElement.classList.add('hide');
      }
    });
  },
});
